import React, { useState, useEffect, useRef } from "react";
import "primereact/resources/themes/saga-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import { Carousel } from "react-bootstrap";
import "assets/css/caro.css";
import { loadApi } from "services/appApi";

const CellAssembly = () => {
  const [dataLength, setDataLength] = useState(0);
  console.log("dataLength", dataLength);
  const [data, setData] = useState([]);
  const [data1, setData1] = useState([]);
  const [data2, setData2] = useState([]);
  const [head, setHead] = useState([]);
  const [time, setTime] = useState("00:00");
  const [isLoading, setIsLoading] = useState(false);
  const [LoadingErrors, setLoadingErrors] = useState(false);

  const p_param = {
    p_process_id: 100,
  };

  const getCurrentTimeInMinutes = () => {
    const now = new Date();
    return now.getHours() * 60 + now.getMinutes();
  };

  const formatTime = (minutes) => {
    let hours = Math.floor(minutes / 60);
    let mins = minutes % 60;
    return `${String(hours).padStart(2, "0")}:${String(mins).padStart(2, "0")}`;
  };

  const formatNumber = (num) => num.toLocaleString();

  const duration = 2000;

  const fetchData = async () => {
    try {
      setIsLoading(true);

      let res = await loadApi(
        p_param,
        "/api/dashboard/getProcProductionStatus"
      );
      //        let res = await getDataApi("EffOpTimePageLoad");
      if (res) {
        let successFlag = res.data[0];
        const fetchedTime = getCurrentTimeInMinutes();
        //   console.log(res);
        if (successFlag === "Y") {
          const dataArray = Array.isArray(res.data[2]) ? res.data[2] : [];
          const length = dataArray.length;
          console.log("length: ", length);
          setDataLength(length);
          if (length === 1) {
            const fetchedData = res.data[2]?.[0];
            console.log("Fetched Data: ", fetchedData);
            setData(fetchedData);
            animateValue(0, fetchedData.plan_qty, duration, (val) =>
              setData((prev) => ({ ...prev, plan_qty: formatNumber(val) }))
            );
            animateValue(0, fetchedData.prod_qty, duration, (val) =>
              setData((prev) => ({ ...prev, prod_qty: formatNumber(val) }))
            );
            animateValue(0, fetchedData.mach_efficiency, duration, (val) =>
              setData((prev) => ({
                ...prev,
                mach_efficiency: formatNumber(val),
              }))
            );
            animateValue(0, fetchedData.month_achievement, duration, (val) =>
              setData((prev) => ({
                ...prev,
                month_achievement: formatNumber(val),
              }))
            );
            animateValue(0, fetchedData.month_prod_qty, duration, (val) =>
              setData((prev) => ({
                ...prev,
                month_prod_qty: formatNumber(val),
              }))
            );
          } else {
            const fetchedData1 = res.data[2]?.[0];
            const fetchedData2 = res.data[2]?.[1];
            console.log("Fetched Data1: ", fetchedData1);
            console.log("Fetched Data2: ", fetchedData2);
            setData1(fetchedData1);
            setData2(fetchedData2);
            animateValue(0, fetchedData1.plan_qty, duration, (val) =>
              setData((prev) => ({ ...prev, plan_qty: val }))
            );
            animateValue(0, fetchedData1.prod_qty, duration, (val) =>
              setData1((prev) => ({ ...prev, prod_qty: formatNumber(val) }))
            );
            animateValue(0, fetchedData1.mach_efficiency, duration, (val) =>
              setData1((prev) => ({
                ...prev,
                mach_efficiency: formatNumber(val),
              }))
            );
            animateValue(0, fetchedData1.month_achievement, duration, (val) =>
              setData1((prev) => ({
                ...prev,
                month_achievement: formatNumber(val),
              }))
            );
            animateValue(0, fetchedData1.month_prod_qty, duration, (val) =>
              setData1((prev) => ({
                ...prev,
                month_prod_qty: formatNumber(val),
              }))
            );
            animateValue(0, fetchedData2.plan_qty, duration, (val) =>
              setData2((prev) => ({ ...prev, plan_qty: formatNumber(val) }))
            );
            animateValue(0, fetchedData2.prod_qty, duration, (val) =>
              setData2((prev) => ({ ...prev, prod_qty: formatNumber(val) }))
            );
            animateValue(0, fetchedData2.mach_efficiency, duration, (val) =>
              setData2((prev) => ({
                ...prev,
                mach_efficiency: formatNumber(val),
              }))
            );
            animateValue(0, fetchedData2.month_achievement, duration, (val) =>
              setData2((prev) => ({
                ...prev,
                month_achievement: formatNumber(val),
              }))
            );
            animateValue(0, fetchedData2.month_prod_qty, duration, (val) =>
              setData2((prev) => ({
                ...prev,
                month_prod_qty: formatNumber(val),
              }))
            );
          }
          animateValue(0, fetchedTime, duration, (val) =>
            setTime(formatTime(val))
          );
          setHead(res.data[1]);
          console.log("month", head);
          console.log(res.data[2]);
          console.log("line1", data1);
          setIsLoading(false);
        } else {
          setLoadingErrors(res.data[3]);
          setIsLoading(false);
        }
      } else {
        setIsLoading(false);
      }
    } catch (err) {
      console.log(err);
      setLoadingErrors(err);
    }
  };

  const animateValue = (start, end, duration, updateFunction) => {
    let startTime = performance.now();

    const step = (timestamp) => {
      let progress = Math.min((timestamp - startTime) / duration, 1);
      let newValue = Math.round(start + progress * (end - start));

      updateFunction(newValue);

      if (progress < 1) requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
  };

  useEffect(() => {
    fetchData();
    const interval = setInterval(fetchData, 60000);
    return () => clearInterval(interval);
  }, []);

  return (
    <>
    <style>
  {`
    html,
    body,
    div#app {
      height: 100%;
    }

    body,
    table.table * {
      background-color: darkblue !important;
    }

    body,
    div#app > div.row,
    table.table-dashboard * {
      color: lightgray !important;
      font-family: Helvetica !important;
    }
  `}
</style>
    <div id="app" className="container-fluid">
      <div id="app" className="container-fluid pt-2">
        <div class="row justify-content-between mb-5 text-center">
          <div class="col-12 offset-xxl-2 col-xxl-8 mt-3">
            <h1 class="fw-bold mb-0" style={{ fontSize: "9.5vh" }}>
              Cell Production Status
            </h1>
          </div>
          <div class="col-12 col-xxl-2">
            <h2
              class="d-flex flex-column mb-0 me-3 lh-1 text-end fw-bold"
              style={{ fontSize: "7.5vh" }}
            >
              As of: {time}
            </h2>
          </div>
        </div>
        <div className="row justify-content-center">
          <div className="col">
            <table className="table table-borderless table-dashboard mb-0 lh-1 text-center">
              <thead>
                <tr>
                  <th className="w-25" />
                  <th className="w-37">
                    <span className="text-table-dashboard text-table-dashboard-heading">
                      Line 1
                    </span>
                  </th>
                  <th className="w-37">
                    <span class="text-table-dashboard text-table-dashboard-heading">
                      Line 2
                    </span>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th className="align-middle">Plan Qty</th>
                  {dataLength === 1 ? (
                    <>
                      <td className="fw-bold">
                        {data.line_number == "1" && data.plan_qty != null ? (
                          <span className="text-table-dashboard text-table-dashboard-number">
                            {" "}
                            {data.plan_qty}
                          </span>
                        ) : (
                          <span className="text-table-dashboard text-table-dashboard-empty">
                            N/A
                          </span>
                        )}
                      </td>
                      <td className="fw-bold">
                        {data.line_number == "2" && data.plan_qty != null ? (
                          <span className="text-table-dashboard text-table-dashboard-number">
                            {data.plan_qty}
                          </span>
                        ) : (
                          <span className="text-table-dashboard text-table-dashboard-empty">
                            N/A
                          </span>
                        )}
                      </td>
                    </>
                  ) : (
                    <>
                      <td className="fw-bold">
                        {data1.line_number == "1" && data1.plan_qty != null ? (
                          <span className="text-table-dashboard text-table-dashboard-number">
                            {data1.plan_qty}{" "}
                          </span>
                        ) : (
                          <span className="text-table-dashboard text-table-dashboard-empty">
                            N/A
                          </span>
                        )}
                      </td>
                      <td className="fw-bold">
                        {data2.line_number == "2" && data2.plan_qty != null ? (
                          <span className="text-table-dashboard text-table-dashboard-number">
                            {" "}
                            {data2.plan_qty}{" "}
                          </span>
                        ) : (
                          <span className="text-table-dashboard text-table-dashboard-empty">
                            N/A
                          </span>
                        )}
                      </td>
                    </>
                  )}
                </tr>
                <tr>
                  <th className="align-middle">Prod Qty</th>
                  {dataLength === 1 ? (
                    <>
                      <td className="fw-bold">
                        {data.line_number == "1" && data.prod_qty != null ? (
                          <span className="text-table-dashboard text-table-dashboard-number">
                            {data.prod_qty}{" "}
                          </span>
                        ) : (
                          <span className="text-table-dashboard text-table-dashboard-empty">
                            N/A
                          </span>
                        )}
                      </td>
                      <td className="fw-bold">
                        {data.line_number == "2" && data.prod_qty != null ? (
                          <span className="text-table-dashboard text-table-dashboard-number">
                            {data.prod_qty}{" "}
                          </span>
                        ) : (
                          <span className="text-table-dashboard text-table-dashboard-empty">
                            N/A
                          </span>
                        )}
                      </td>
                    </>
                  ) : (
                    <>
                      <td className="fw-bold">
                        {data1.line_number == "1" && data1.prod_qty != null ? (
                          <span className="text-table-dashboard text-table-dashboard-number">
                            {" "}
                            {data1.prod_qty}{" "}
                          </span>
                        ) : (
                          <span className="text-table-dashboard text-table-dashboard-empty">
                            N/A
                          </span>
                        )}
                      </td>
                      <td className="fw-bold">
                        {data2.line_number == "2" && data2.prod_qty != null ? (
                          <span className="text-table-dashboard text-table-dashboard-number">
                            {data2.prod_qty}{" "}
                          </span>
                        ) : (
                          <span className="text-table-dashboard text-table-dashboard-empty">
                            N/A
                          </span>
                        )}
                      </td>
                    </>
                  )}
                </tr>
                <tr>
                  <th class="align-middle">Mach Eff</th>
                  {dataLength === 1 ? (
                    <>
                      <td className="fw-bold">
                        {data.line_number == "1" &&
                        data.mach_efficiency != null ? (
                          <span class="text-table-dashboard text-table-dashboard-percent">{`${data.mach_efficiency}%`}</span>
                        ) : (
                          <span className="text-table-dashboard text-table-dashboard-empty">
                            N/A
                          </span>
                        )}
                      </td>
                      <td className="fw-bold">
                        {data.line_number == "2" &&
                        data.mach_efficiency != null ? (
                          <span className="text-table-dashboard text-table-dashboard-percent">
                            {`${data.mach_efficiency}%`}{" "}
                          </span>
                        ) : (
                          <span className="text-table-dashboard text-table-dashboard-empty">
                            N/A
                          </span>
                        )}
                      </td>
                    </>
                  ) : (
                    <>
                      <td className="fw-bold">
                        {data1.line_number == "1" &&
                        data1.mach_efficiency != null ? (
                          <span className="text-table-dashboard text-table-dashboard-percent">{`${data1.mach_efficiency}%`}</span>
                        ) : (
                          <span className="text-table-dashboard text-table-dashboard-empty">
                            N/A
                          </span>
                        )}
                      </td>
                      <td className="fw-bold">
                        {data2.line_number == "2" &&
                        data2.mach_efficiency != null ? (
                          <span className="text-table-dashboard text-table-dashboard-percent">{`${data2.mach_efficiency}%`}</span>
                        ) : (
                          <span className="text-table-dashboard text-table-dashboard-empty">
                            N/A
                          </span>
                        )}
                      </td>
                    </>
                  )}
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div className="row justify-content-center">
          <div className="col">
            <Carousel
              id="demo"
              interval={5000}
              pause={false}
              controls={false}
              indicators={false}
              className="carousel border-end-0 border-bottom-0 border-start-0 border-top border-3 slide pt-4 "
            >
              <Carousel.Item>
                <table
                  style={{ tableLayout: "fixed", width: "100%" }}
                  className="table table-borderless table-dashboard text-center lh-1"
                >
                  <tbody>
                    <tr>
                      <th className="w-25">{head} Prod Qty</th>
                      {dataLength === 1 ? (
                        <>
                          {" "}
                          <td className="w-37 fw-bold">
                            {data.line_number == "1" &&
                            data.month_prod_qty != null ? (
                              <span className="text-table-dashboard text-table-dashboard-number">
                                {data.month_prod_qty}
                              </span>
                            ) : (
                              <span className="text-table-dashboard text-table-dashboard-empty">
                                N/A
                              </span>
                            )}
                          </td>
                          <td class="w-37 fw-bold">
                            {data.line_number == "2" &&
                            data.month_prod_qty != null ? (
                              <span className="text-table-dashboard text-table-dashboard-number">
                                {" "}
                                {data.month_prod_qty}
                              </span>
                            ) : (
                              <span className="text-table-dashboard text-table-dashboard-empty">
                                N/A
                              </span>
                            )}
                          </td>
                        </>
                      ) : (
                        <>
                          <td className="w-37 fw-bold">
                            {data1.line_number == "1" &&
                            data1.month_prod_qty != null ? (
                              <span className="text-table-dashboard text-table-dashboard-number">
                                {data1.month_prod_qty}
                              </span>
                            ) : (
                              <span className="text-table-dashboard text-table-dashboard-empty">
                                N/A
                              </span>
                            )}
                          </td>
                          <td className="w-37 fw-bold">
                            {data2.line_number == "2" &&
                            data2.month_prod_qty != null ? (
                              <span className="text-table-dashboard text-table-dashboard-number">
                                {" "}
                                {data2.month_prod_qty}{" "}
                              </span>
                            ) : (
                              <span className="text-table-dashboard text-table-dashboard-empty">
                                N/A
                              </span>
                            )}
                          </td>
                        </>
                      )}
                    </tr>
                  </tbody>
                </table>
              </Carousel.Item>
              <Carousel.Item>
                <table
                  style={{ tableLayout: "fixed", width: "100%" }}
                  className="table table-borderless table-dashboard text-center lh-1"
                >
                  <tbody>
                    <tr>
                      <th className="w-25">{head} Achmt</th>
                      {dataLength === 1 ? (
                        <>
                          {" "}
                          <td className="w-37 fw-bold">
                            {data.line_number == "1" &&
                            data.month_achievement != null ? (
                              <span className="text-table-dashboard text-table-dashboard-percent">{`${data.month_achievement}%`}</span>
                            ) : (
                              <span className="text-table-dashboard text-table-dashboard-empty">
                                N/A
                              </span>
                            )}
                          </td>
                          <td className="w-37 fw-bold">
                            {data.line_number == "2" &&
                            data.month_achievement != null ? (
                              <span className="text-table-dashboard text-table-dashboard-percent">
                                {" "}
                                {`${data.month_achievement}%`}{" "}
                              </span>
                            ) : (
                              <span className="text-table-dashboard text-table-dashboard-empty">
                                N/A
                              </span>
                            )}
                          </td>
                        </>
                      ) : (
                        <>
                          <td className="w-37 fw-bold">
                            {data1.line_number == "1" &&
                            data1.month_achievement != null ? (
                              <span className="text-table-dashboard text-table-dashboard-percent">
                                {" "}
                                {`${data1.month_achievement}%`}
                              </span>
                            ) : (
                              <span className="text-table-dashboard text-table-dashboard-empty">
                                N/A
                              </span>
                            )}
                          </td>
                          <td className="w-37 fw-bold">
                            {data2.line_number == "2" &&
                            data2.month_achievement != null ? (
                              <span className="text-table-dashboard text-table-dashboard-percent">
                                {" "}
                                {`${data2.month_achievement}%`}{" "}
                              </span>
                            ) : (
                              <span className="text-table-dashboard text-table-dashboard-empty">
                                N/A
                              </span>
                            )}
                          </td>
                        </>
                      )}
                    </tr>
                  </tbody>
                </table>
              </Carousel.Item>
            </Carousel>
          </div>
        </div>
      </div>
    </div>
    </>
  );
};



export default CellAssembly;
